import {
  Box,
  HStack,
  IconButton,
  useBreakpointValue,
  usePrevious,
  useUpdateEffect,
  VStack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";

import { ConnectWalletButton } from "../connect-wallet-button";
import { HomeLink } from "../home-link";
import { ConnectedWalletModal } from "../modals/connected-wallet-modal";

import { DailySpinPopover } from "./daily-spin-popover";

import { DesktopNavbar } from "@/components/navbar/desktop-navbar";
import { MobileNavbar } from "@/components/navbar/mobile-navbar";
import { useCompliance } from "@/hooks/useCompliance";
import { useCurrentUserData } from "@/hooks/useCurrentUserData";

export const AppHeader = () => {
  const { address } = useCurrentUserData();
  const { geoCompliance } = useCompliance();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const previousAddress = usePrevious(address);

  const isMobile = useBreakpointValue({ base: true, md: false });
  const shouldShowConnectWallet =
    geoCompliance?.restrictAccess !== true &&
    (!address || (!isMobile && !isMenuOpen));

  useUpdateEffect(() => {
    if (previousAddress !== address) {
      setIsMenuOpen(false);
    }
  }, [address]);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    };
  }, [isMenuOpen]);

  // On mobile when navigating to a new page, the menu should close
  useUpdateEffect(() => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [location]);

  return (
    <HStack
      borderBottomWidth="thin"
      borderBottomColor="border" //"border"  TODO COLOR PALETTE
      position="fixed"
      zIndex="sticky"
      w="full"
      bg="bg"
    >
      <HStack
        maxW="1200px"
        w="full"
        mx="auto"
        justifyContent="space-between"
        py={4}
        h="full"
        bg="transparent"
      >
        <HomeLink />
        {!isMobile && <DesktopNavbar />}
        <HStack>
          {address && isMobile && <DailySpinPopover />}
          {shouldShowConnectWallet && <ConnectWalletButton />}
          {((address && isMobile) || isMenuOpen) && (
            <IconButton
              aria-label="Menu"
              variant="outline"
              borderRadius="full"
              borderWidth="1px"
              borderColor="border"
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H3.125C2.95924 10.625 2.80027 10.5592 2.68306 10.4419C2.56585 10.3247 2.5 10.1658 2.5 10C2.5 9.83424 2.56585 9.67527 2.68306 9.55806C2.80027 9.44085 2.95924 9.375 3.125 9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10ZM3.125 5.625H16.875C17.0408 5.625 17.1997 5.55915 17.3169 5.44194C17.4342 5.32473 17.5 5.16576 17.5 5C17.5 4.83424 17.4342 4.67527 17.3169 4.55806C17.1997 4.44085 17.0408 4.375 16.875 4.375H3.125C2.95924 4.375 2.80027 4.44085 2.68306 4.55806C2.56585 4.67527 2.5 4.83424 2.5 5C2.5 5.16576 2.56585 5.32473 2.68306 5.44194C2.80027 5.55915 2.95924 5.625 3.125 5.625ZM16.875 14.375H3.125C2.95924 14.375 2.80027 14.4408 2.68306 14.5581C2.56585 14.6753 2.5 14.8342 2.5 15C2.5 15.1658 2.56585 15.3247 2.68306 15.4419C2.80027 15.5592 2.95924 15.625 3.125 15.625H16.875C17.0408 15.625 17.1997 15.5592 17.3169 15.4419C17.4342 15.3247 17.5 15.1658 17.5 15C17.5 14.8342 17.4342 14.6753 17.3169 14.5581C17.1997 14.4408 17.0408 14.375 16.875 14.375Z"
                  fill="#111111"
                />
              </svg>
            </IconButton>
          )}
        </HStack>
        {isMenuOpen && (
          <Box
            position="fixed"
            top={73}
            left={0}
            right={0}
            bgColor="bg"
            bottom={0}
            zIndex="sticky"
            p={4}
            overflow="auto"
          >
            <MobileNavbar />

            <VStack
              position="fixed"
              bottom={0}
              left={0}
              right={0}
              bgColor="rgba(255, 255, 255, 0.50)"
              p={4}
              backdropFilter="blur(2px)"
            >
              <ConnectedWalletModal />
            </VStack>
          </Box>
        )}
      </HStack>
    </HStack>
  );
};
